
<template>
  <div id="page-content-add">

    <vx-card title="컨텐츠 상세 정보" class="mb-base" >

      <listening-sound-form v-if="menuCode === 'L010'"  class="mt-4" 
        @onDataChanged="onDataChanged"
        :content="content" 
        :edit-mode="true" />

      <listening-with-pictures-form v-if="menuCode === 'L020'"  class="mt-4" 
        @onDataChanged="onDataChanged"
        :content="content" 
        :edit-mode="true" />

      <listening-with-subtitles-form v-if="menuCode === 'L030'"  class="mt-4" 
        @onDataChanged="onDataChanged"
        :content="content" 
        :edit-mode="true"/>

      <listening-korean-form v-if="menuCode === 'L040'"  class="mt-4" 
        @onDataChanged="onDataChanged"
        :content="content" 
        :edit-mode="true" />

      <listening-words-form v-if="menuCode === 'V010'"  class="mt-4" 
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <listening-words-form-v08 v-if="menuCode === 'V080'"  class="mt-4" 
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />

      <speaking-words-form v-if="menuCode === 'V020'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />
  
      <words-dictation1-form v-if="menuCode === 'V030'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <words-dictation2-form v-if="menuCode === 'V031'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <words-dictation3-form v-if="menuCode === 'V032'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <writing-words-form v-if="menuCode === 'V040'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <checking-words-form v-if="menuCode === 'V050'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <intonation-reading-form v-if="menuCode === 'R020'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <speed-reading1-form v-if="menuCode === 'R030'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <speed-reading2-form v-if="menuCode === 'R031'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <reading-and-translating-form v-if="menuCode === 'R040'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <shadow-readings-form v-if="menuCode === 'R060'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <listen-and-fill-in-Form reading-and-translating-form v-if="menuCode === 'L070'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <sentence-dictation-type1-form v-if="menuCode === 'L080'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />

      <sentence-dictation-type2-form v-if="menuCode === 'L081'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />

      <sentence-speaking-form v-if="menuCode === 'S010'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"   />

      <role-play-form v-if="menuCode === 'S020'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <speak-straight1-form v-if="menuCode === 'S030'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />

      <speak-straight2-form v-if="menuCode === 'S031'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />

      <pattern-practice-form v-if="menuCode === 'S050'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />

      <matching-sentences-form v-if="menuCode === 'W010'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />

      <writing-blank-type1-form v-if="menuCode === 'W020'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <writing-blank-type2-form v-if="menuCode === 'W021'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <writing-blank-type3-form v-if="menuCode === 'W022'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <writing-blank-type4-form v-if="menuCode === 'W023'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <writing-composition-form v-if="menuCode === 'W030'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />

      <reading-and-speaking-form v-if="menuCode === 'R050'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />

      <listening-phonics1-form v-if="menuCode === 'P050'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />        

      <listening-phonics2-form v-if="menuCode === 'P060'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />        

      <speaking-phonics1-form v-if="menuCode === 'P070'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />        

      <speaking-phonics2-form v-if="menuCode === 'P080'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />        

      <matching-phonics1-form v-if="menuCode === 'P090'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />        

      <matching-phonics2-form v-if="menuCode === 'P100'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />        

      <writing-phonics1-form v-if="menuCode === 'P110'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />        

      <writing-phonics2-form v-if="menuCode === 'P120'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />        

      <pattern-extension1-form v-if="menuCode === 'S060'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />        

      <pattern-extension2-form v-if="menuCode === 'S061'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />        

      <pattern-extension3-form v-if="menuCode === 'S062'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />        

      <listening-phonics-form v-if="menuCode === 'P010'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />        

      <speaking-phonics-form v-if="menuCode === 'P020'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />        

      <matching-phonics-form v-if="menuCode === 'P030'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"  />        

      <writing-phonics-form v-if="menuCode === 'P040'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />        

      <memorizing-words1-form v-if="menuCode === 'V070'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />    

      <memorizing-words2-form v-if="menuCode === 'V071'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true" />    

      <grammar-explanation-form v-if="menuCode === 'G010'"  class="mt-4"
         @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"/> 

      <check-up-form v-if="menuCode === 'C010'"  class="mt-4"
        @onDataChanged="onDataChanged"
        :content="content"
        :edit-mode="true"/>  


      <div class="vx-col w-full flex justify-end mt-6" id="account-manage-buttons">
        <vs-button color="danger" class="mr-4" @click="confirmDelete">삭제</vs-button>
      </div>
    </vx-card>

  </div>
</template>

<script>
import { fetchData, putData, deleteData } from '@/api/module'
import ContentFilter  from './ContentFilter'
import ListeningSoundForm  from './ListeningSoundForm'
import ListeningWithPicturesForm  from './ListeningWithPicturesForm'
import ListeningWithSubtitlesForm  from './ListeningWithSubtitlesForm'
import ListeningKoreanForm  from './ListeningKoreanForm'
import ListeningWordsForm  from './ListeningWordsForm'
import ListeningWordsFormV08  from './ListeningWordsFormV08'
import SpeakingWordsForm  from './SpeakingWordsForm'
import WordsDictation1Form  from './WordsDictation1Form'
import WordsDictation2Form  from './WordsDictation2Form'
import WordsDictation3Form  from './WordsDictation3Form'
import WritingWordsForm  from './WritingWordsForm'
import CheckingWordsForm  from './CheckingWordsForm'
import IntonationReadingForm  from './IntonationReadingForm'
import SpeedReading1Form  from './SpeedReading1Form'
import SpeedReading2Form  from './SpeedReading2Form'
import ReadingAndTranslatingForm  from './ReadingAndTranslatingForm'
import ListenAndFillInForm  from './ListenAndFillInForm'
import SentenceDictationType1Form  from './SentenceDictationType1Form'
import SentenceDictationType2Form  from './SentenceDictationType2Form'
import SentenceSpeakingForm  from './SentenceSpeakingForm'
import RolePlayForm  from './RolePlayForm'
import SpeakStraight1Form  from './SpeakStraight1Form'
import SpeakStraight2Form  from './SpeakStraight2Form'
import PatternPracticeForm  from './PatternPracticeForm'
import MatchingSentencesForm  from './MatchingSentencesForm'

import WritingBlankType1Form  from './WritingBlankType1Form'
import WritingBlankType2Form  from './WritingBlankType2Form'
import WritingBlankType3Form  from './WritingBlankType3Form'
import WritingBlankType4Form  from './WritingBlankType4Form'

import WritingCompositionForm  from './WritingCompositionForm'
import ReadingAndSpeakingForm  from './ReadingAndSpeakingForm'
import ListeningPhonics1Form  from './ListeningPhonics1Form'
import ListeningPhonics2Form  from './ListeningPhonics2Form'
import SpeakingPhonics1Form  from './SpeakingPhonics1Form'
import SpeakingPhonics2Form  from './SpeakingPhonics2Form'
import MatchingPhonics1Form  from './MatchingPhonics1Form'
import MatchingPhonics2Form  from './MatchingPhonics2Form'
import WritingPhonics1Form  from './WritingPhonics1Form'
import WritingPhonics2Form  from './WritingPhonics2Form'

import PatternExtension1Form  from './PatternExtension1Form'
import PatternExtension2Form  from './PatternExtension2Form'
import PatternExtension3Form  from './PatternExtension3Form'

import ShadowReadingsForm  from './ShadowReadingsForm'
import ListeningPhonicsForm  from './ListeningPhonicsForm'
import SpeakingPhonicsForm  from './SpeakingPhonicsForm'
import MatchingPhonicsForm  from './MatchingPhonicsForm'
import WritingPhonicsForm  from './WritingPhonicsForm'

import MemorizingWords1Form  from './MemorizingWords1Form'
import MemorizingWords2Form  from './MemorizingWords2Form'
import GrammarExplanationForm  from './GrammarExplanationForm'
import CheckUpForm  from './CheckUpForm'

export default {
  components: {
    ContentFilter,
    ListeningSoundForm,
    ListeningWithPicturesForm,
    ListeningWithSubtitlesForm,
    ListeningKoreanForm,
    ListeningWordsForm,
    ListeningWordsFormV08,
    SpeakingWordsForm,
    WordsDictation1Form,
    WordsDictation2Form,
    WordsDictation3Form,
    WritingWordsForm,
    CheckingWordsForm,
    IntonationReadingForm,
    SpeedReading1Form,
    SpeedReading2Form,
    ReadingAndTranslatingForm,
    ListenAndFillInForm,
    SentenceDictationType1Form,
    SentenceDictationType2Form,
    SentenceSpeakingForm,
    RolePlayForm,
    SpeakStraight1Form,
    SpeakStraight2Form,
    PatternPracticeForm,
    MatchingSentencesForm,
    WritingBlankType1Form,
    WritingBlankType2Form,
    WritingBlankType3Form,
    WritingBlankType4Form,
    WritingCompositionForm,
    ReadingAndSpeakingForm,
    ListeningPhonics1Form,
    ListeningPhonics2Form,
    SpeakingPhonics1Form,
    SpeakingPhonics2Form,
    MatchingPhonics1Form,
    MatchingPhonics2Form,
    WritingPhonics1Form,
    WritingPhonics2Form,
    PatternExtension1Form,
    PatternExtension2Form,
    PatternExtension3Form,
    ShadowReadingsForm,
    ListeningPhonicsForm,
    SpeakingPhonicsForm,
    MatchingPhonicsForm,
    WritingPhonicsForm,
    MemorizingWords1Form,
    MemorizingWords2Form,
    GrammarExplanationForm,
    CheckUpForm
  },
  data () {
    return {
      content: null,
      menuCode: ''
    }
  },
  watch: {
  },
  methods: {
    onDataChanged (val) {

      const formData = new FormData()
      formData.append('studyContentSeq', this.content.studyContentSeq)
      formData.append('contentCode', this.content.contentCode)
      formData.append('bookCode', this.content.bookCode)
      formData.append('unitCode', this.content.unitCode)
      formData.append('menuCode', this.content.menuCode)
      formData.append('stepCode', this.content.stepCode)
      
      if (val.hasOwnProperty('sentence')) {
        formData.append('sentence', JSON.stringify(val.sentence))
      }
      if (val.hasOwnProperty('translation')) {
        formData.append('translation', JSON.stringify(val.translation))
      }
      if (val.hasOwnProperty('dictation')) {
        formData.append('dictation', JSON.stringify(val.dictation))
      }
      if (val.hasOwnProperty('example')) {
        formData.append('example', JSON.stringify(val.example))
      }
      if (val.hasOwnProperty('answer')) {
        formData.append('answer', JSON.stringify(val.answer))
      }
      if (val.hasOwnProperty('role')) {
        formData.append('role', JSON.stringify(val.role))
      }
      if (val.hasOwnProperty('exampleTranslation')) {
        formData.append('exampleTranslation', JSON.stringify(val.exampleTranslation))
      }
      if (val.hasOwnProperty('exampleDictation')) {
        formData.append('exampleDictation', JSON.stringify(val.exampleDictation))
      }
      putData('study-content', formData, { 
        headers : { 
          'Content-Type': 'multipart/form-data'
        }
      })
      this.$router.push('/content/content-list')
    },
    confirmDelete () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '삭제',
        text: '삭제 하시겠습니까?',
        accept: this.deleteContent,
        acceptText: '삭제'
      })
    },
    async deleteContent () {

      try {
        await deleteData(`study-content/${this.content.studyContentSeq}`)
        this.$router.push('/content/content-list')
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  
  
  async created () {
    try { 
      const studyContentSeq = this.$route.params.studyContentSeq
      const { data } = await fetchData(`study-content/${studyContentSeq}`)
      this.content = data.data
      this.menuCode = this.content.menuCode
    } catch (error) {

      this.$vs.notify({
        title: 'Error',
        text: error.response.data.msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      }) 
    }
  }
}

</script>
